import { render, staticRenderFns } from "./AttendanceWarningModal.vue?vue&type=template&id=71207e54"
import script from "./AttendanceWarningModal.vue?vue&type=script&lang=js"
export * from "./AttendanceWarningModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports